import { ProfileImageView } from './ProfileImageView';

export default ProfileImageView;
